<app-clickable-card (click)="onSequenceClick()">
  <div class="container">
    @if (sequence.noSequence) {
    <div class="header">
      <div></div>
      <app-status-badge [status]="noSequenceStatus" />
      <div></div>
    </div>
    <div class="no-sequence-container">
      <i class="pi pi-calendar"></i>
      <div>No scheduled sequence</div>
    </div>
    } @else {
    <div class="header">
      @if (sequence.sequence) {
      <div class="seq-number">{{ sequence.sequence }}</div>
      } @else {
      <div class="seq-number">
        <p-skeleton width="5rem" height="1rem" />
      </div>
      }
      <app-status-badge [status]="sequence.state" />
      <div class="icon-value-group">
        <i class="icon pi pi-clock"></i>
        @if(sequence.sequence) {
        <div class="value">{{ sequence.credit }}</div>
        } @else {
        <div class="value">
          <p-skeleton width="2.5rem" height="1rem" />
        </div>
        }
      </div>
    </div>
    <div class="body">
      <div class="times">
        <div class="time-group">
          @if (sequence.sequence) {
          <div class="value">
            {{ sequence.originate.date }}
            <span style="color: var(--text-color-secondary)">{{ sequence.originate.time }}L</span>
          </div>
          } @else {
          <div class="value">
            <p-skeleton width="8rem" height="1rem" />
          </div>
          }
          <div class="label">Origination</div>
        </div>
        <div class="vertical-divider"></div>
        <div class="time-group">
          @if (sequence.sequence) {
          <div class="value">
            {{ sequence.terminate.date }}
            <span style="color: var(--text-color-secondary)">{{ sequence.terminate.time }}L</span>
          </div>
          } @else {
          <div class="value">
            <p-skeleton width="8rem" height="1rem" />
          </div>
          }
          <div class="label">Termination</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="label-value-group">
        @if (showLabel()) {
        <div class="label">Layovers</div>
        } @if (sequence.sequence) {
        <div class="value">{{ sequence.layovers }}</div>
        } @else {
        <div class="value">
          <p-skeleton width="4rem" height="1rem" />
        </div>
        }
      </div>
      <div class="label-value-group">
        @if (showLabel()) {
        <div class="label">Legs</div>
        } @if (sequence.sequence) {
        <div class="value">{{ sequence.legs }}</div>
        } @else {
        <div class="value">
          <p-skeleton width="4rem" height="1rem" />
        </div>
        }
      </div>
    </div>
    }
  </div>
</app-clickable-card>
